import { create } from 'zustand';
import { billingService } from '../services/billingService';

export const useBillingStore = create((set, get) => ({
  credits: 0,
  transactions: [],
  loading: false,
  error: null,
  stripePublicKey: null,
  // 订阅配置
  subscriptionConfig: null, // { publishableKey, basicPrice, proPrice }

  // Fetch user credits
  fetchCredits: async () => {
    try {
      set({ loading: true, error: null });
      const response = await billingService.getUserCredits();
      set({ credits: response.credits, loading: false });
    } catch (error) {
      set({ error: error.message, loading: false });
    }
  },

  // Fetch Stripe public key
  fetchStripePublicKey: async () => {
    try {
      const response = await billingService.getStripePublicKey();
      set({ stripePublicKey: response.publicKey });
    } catch (error) {
      set({ error: error.message });
    }
  },

  // 获取订阅配置（包含 publishableKey 与两个价格ID）
  fetchSubscriptionConfig: async () => {
    try {
      const config = await billingService.getSubscriptionConfig();

      const { publishableKey, proPrice } = config || {};
      set({
        subscriptionConfig: config,
        stripePublicKey: publishableKey || get().stripePublicKey,
      });
      return { publishableKey, proPrice };
    } catch (error) {
      set({ error: error.message });
      throw error;
    }
  },

  // Fetch transaction history
  fetchTransactions: async (page = 1, limit = 20) => {
    try {
      set({ loading: true, error: null });
      const response = await billingService.getTransactionHistory(page, limit);
      set({ 
        transactions: response.transactions, 
        loading: false 
      });
      return response;
    } catch (error) {
      set({ error: error.message, loading: false });
    }
  },

  // Update credits (after successful purchase)
  updateCredits: (newCredits) => {
    set({ credits: newCredits });
  },

  // Clear error
  clearError: () => {
    set({ error: null });
  },
})); 